import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

// New Shayamal hero image
const HERO_IMAGE = "https://customer-assets.emergentagent.com/job_peak-mastery/artifacts/vxkjfdze_new%20version.jpg";

export const HeroSection = () => {
  return (
    <section
      data-testid="hero-section"
      className="relative min-h-screen flex items-center bg-[#F4F1EC] overflow-hidden"
    >
      <div className="container-peak relative z-10 py-20 lg:py-32">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="order-2 lg:order-1 text-center lg:text-left"
          >
            <motion.span
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="section-tag block mb-4 lg:mb-6"
            >
              Human Performance Designer
            </motion.span>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light leading-[1.1] mb-4 lg:mb-6 text-[#1F2A44]">
              Transform your potential into{' '}
              <em className="not-italic text-[#D97904]">extraordinary results</em>
            </h1>

            <p className="text-[#5A6B7A] text-base lg:text-lg max-w-lg mx-auto lg:mx-0 mb-8 lg:mb-10 leading-relaxed">
              Science-backed strategies for sustainable peak performance. Used by world-class athletes, Fortune 500 leaders, and high-performing teams.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <motion.a
                href="#programs"
                data-testid="hero-learn-btn"
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                className="btn-primary inline-flex items-center justify-center gap-3"
              >
                Learn More
                <ArrowRight size={16} />
              </motion.a>
              <motion.a
                href="https://calendar.app.google/evsn9LsubajagFF3A"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="hero-contact-btn"
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                className="btn-ghost inline-flex items-center justify-center gap-3"
              >
                Get in Touch
              </motion.a>
            </div>
          </motion.div>

          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="order-1 lg:order-2 relative flex justify-center items-center"
          >
            <div className="relative w-full max-w-[260px] sm:max-w-[320px] lg:max-w-[380px] mx-auto">
              {/* Decorative elements */}
              <div className="absolute -top-3 -right-3 lg:-top-4 lg:-right-4 w-16 lg:w-24 h-16 lg:h-24 border border-[#D97904]/30 -z-10" />
              <div className="absolute -bottom-3 -left-3 lg:-bottom-4 lg:-left-4 w-16 lg:w-24 h-16 lg:h-24 bg-[#D97904]/10 -z-10" />
              
              <img
                src={HERO_IMAGE}
                alt="Shayamal Vallabhjee - Human Performance Designer"
                className="w-full h-auto object-contain max-h-[500px] lg:max-h-[600px]"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
